import { render, staticRenderFns } from "./activityManage.vue?vue&type=template&id=ba3a928e&scoped=true&"
import script from "./activityManage.vue?vue&type=script&lang=js&"
export * from "./activityManage.vue?vue&type=script&lang=js&"
import style0 from "./activityManage.vue?vue&type=style&index=0&id=ba3a928e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3a928e",
  null
  
)

export default component.exports